import React, { useContext } from 'react';
import { Link } from 'react-router-dom';
import './HomeNews.scss';
import Img1 from '../../../../assets/img/gameIndustry.jpg';
import Img2 from '../../../../assets/img/gameEvent.jpg';
import Img3 from '../../../../assets/img/gameTrend.jpg';
import { Context } from '../../../../index';

function HomeNews() {

    const {store} = useContext(Context)
    const newsData = store.getState().news.news

    

    return (
        <section className="news">
            <div className="container">
                <div className="title_part">
                    <h3>Updates</h3>
                    <div className="btn button-underline">
                        <Link
                            className="link"
                            to={{ pathname: "/updates" }}
                        >See all Updates & events.
                        </Link>
                    </div>
                </div>
                <div className="news_cards">
                    {newsData.slice(0,3).map(news => (
                        <div key={news.id} className="news_card" data-aos="zoom-in-up" data-aos-duration="3000">
                            <div className="img">
                                <img src={news.img} alt="" />
                            </div>
                            <div className="category"> updates</div>
                            <h4>
                                <Link
                                    className="link"
                                    to={{ pathname: "/updates/" + news.link }}>
                                    {news.title}
                                </Link>
                            </h4>
                            <p>
                                {news.name.slice(0,125)}...
                            </p>
                            <span className="btn button-underline">
                                <Link
                                    className="link"
                                    to={{ pathname: '/updates/' + news.link }}>
                                    Show more
                                </Link>
                            </span>
                        </div>
                    ))}
                </div>
            </div>
        </section>
    )
}

export default HomeNews
